import { Button, Group, Modal, Text } from '@mantine/core';
import type { PatientMeasurementRecord } from '../types';
import { formatDateTimeValue } from '../utils/formatters';

interface DeletePatientMeasurementDialogProps {
  measurement: PatientMeasurementRecord | null;
  opened: boolean;
  loading?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export function DeletePatientMeasurementDialog({
  measurement,
  opened,
  loading = false,
  onConfirm,
  onClose,
}: DeletePatientMeasurementDialogProps) {
  const dateLabel = measurement?.createdAt
    ? formatDateTimeValue(measurement.createdAt)
    : 'data non disponibile';

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title='Elimina rilevazione'
      centered
    >
      <Text size='sm' c='dimmed'>
        Confermi l&apos;eliminazione della rilevazione del{' '}
        <strong>{dateLabel}</strong>? L&apos;operazione è irreversibile e
        aggiornerà metriche e grafici collegati.
      </Text>

      <Group justify='flex-end' mt='lg'>
        <Button variant='default' onClick={onClose} disabled={loading}>
          Annulla
        </Button>
        <Button color='red' onClick={onConfirm} loading={loading}>
          Elimina
        </Button>
      </Group>
    </Modal>
  );
}
